import React from 'react'
import { FaMediumM, FaTelegramPlane } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'

export default function Footer() {
  return (
    <div class=''>
      <footer class='border-y border-white lg:px-20 md:px-10 px-0'>
        <div class='grid grid-cols-12 md:gap-8 gap-0'>
          <div class='md:border-r border-b border-white py-8 md:col-span-8 col-span-full px-5'>
            <div>
              <img
                src='/images/logo.png'
                alt='logo'
                className='max-w-[276px] animate__flipInX wow animate__animated'
              />
              <p class='mt-6 animate__flipInX wow animate__animated'>
                At the core of Deep Whales AI is a dedicated team deeply
                embedded in the crypto community. Our journey has been forged
                from years of experience & dedication within the crypto space.
                We are traders, innovators, & visionaries, much like those we
                aim to serve. Our roots are entwined with the very community we
                seek to empower.
              </p>
            </div>
          </div>
          <div className='md:col-span-4 col-span-full'>
            <div class='grid grid-cols-2'>
              <div className='border-r border-white py-12 px-5'>
                <h3 class='text-[20px] font-semibold animate__flipInX wow animate__animated'>
                  Quick Links
                </h3>
                <ul class='flex flex-col gap-3 mt-3'>
                  <li>
                    <a
                      href='#about'
                      class='nav-item animate__flipInX wow animate__animated '
                    >
                      ABOUT
                    </a>
                  </li>
                  <li>
                    <a
                      href='#nft'
                      class='nav-item animate__flipInX wow animate__animated'
                    >
                      NFT HODLERS
                    </a>
                  </li>
                  <li>
                    <a
                      href='#features'
                      class='nav-item animate__flipInX wow animate__animated'
                    >
                      FEATURES
                    </a>
                  </li>
                  <li>
                    <a
                      href='#premiumservices'
                      class='nav-item animate__flipInX wow animate__animated'
                    >
                      PREMIUM SERVICE
                    </a>
                  </li>
                </ul>
              </div>
              <div className='py-12 px-5'>
                <h3 class='text-[20px] font-semibold animate__flipInX wow animate__animated'>
                  SOCIALS
                </h3>
                <div className='flex items-center gap-5 pt-5 text-2xl'>
                  <a
                    href=''
                    className='animate__flipInX wow animate__animated'
                  >
                    <FaMediumM />
                  </a>
                  <a
                    href=''
                    className='animate__flipInX wow animate__animated'
                  >
                    <FaXTwitter />
                  </a>
                  <a
                    href=''
                    className='animate__flipInX wow animate__animated'
                  >
                    <FaTelegramPlane />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <p class='text-center py-5'>© Copyright Deep Whales AI 2024</p>
    </div>
  )
}
